export default __webpack_public_path__ + "static/media/Full Belly Footer 2022.99a6c2df.jpg";